import { useLDClient } from 'launchdarkly-react-client-sdk';
import React, { useCallback, useEffect, useMemo } from 'react';

import { BillingDelinquencyGate } from '~hocs/BillingDelinquencyGate';
import { SESSION_ENV_KEY } from '~utils/config';
import { getParsedLocalStorageData } from '~utils/functions';

/*
  The app's only LaunchDarkly identify. It re-fires per top-level route, which is how an
  impersonated session picks up its new business — keep it here.
*/
export const ComponentWithLDUser = ({ component: Component }) => {
	const LDClient = useLDClient();
	const localStorageData = useMemo(
		() => getParsedLocalStorageData(SESSION_ENV_KEY),
		[],
	);

	const registerLaunchDarklyUser = useCallback(() => {
		const user = {
			key: localStorageData?.email,
			email: localStorageData?.email,
			custom: { businessId: localStorageData?.business?.id },
		};

		void LDClient?.identify(user);
	}, [LDClient, localStorageData]);

	useEffect(() => {
		registerLaunchDarklyUser();
	}, [registerLaunchDarklyUser]);

	return (
		<BillingDelinquencyGate>
			<Component />
		</BillingDelinquencyGate>
	);
};
